export const colors = {
  surface: {
    base: '#ffffff',
    subtle: '#f8fafc',
    muted: '#f1f5f9',
  },
  border: {
    subtle: '#e2e8f0',
    strong: '#cbd5f5',
    table: '#eef2ff',
  },
  text: {
    primary: '#0f172a',
    secondary: '#1f2937',
    tertiary: '#475569',
    muted: '#64748b',
  },
  accents: {
    primary: '#2563eb',
    primaryDark: '#1d4ed8',
    primaryDarker: '#1e3a8a',
  },
  status: {
    success: '#166534',
    warning: '#b45309',
    danger: '#b91c1c',
    info: '#1d4ed8',
    neutral: '#6b7280',
  },
  backgroundTones: {
    success: 'rgba(34, 197, 94, 0.2)',
    warning: 'rgba(234, 179, 8, 0.2)',
    danger: 'rgba(248, 113, 113, 0.18)',
    warningSoft: 'rgba(251, 191, 36, 0.22)',
    info: 'rgba(59, 130, 246, 0.15)',
    infoBright: 'rgba(59, 130, 246, 0.22)',
    primarySoft: 'rgba(37, 99, 235, 0.12)',
    neutral: 'rgba(148, 163, 184, 0.22)',
  },
};

export const radii = {
  xl: '18px',
  lg: '16px',
  md: '14px',
  base: '12px',
  sm: '10px',
  pill: '999px',
};

export const shadows = {
  level1: '0 6px 20px rgba(15, 23, 42, 0.08)',
  level2: '0 10px 30px rgba(15, 23, 42, 0.06)',
  level3: '0 16px 40px rgba(30, 64, 175, 0.12)',
  accent: '0 12px 30px rgba(37, 99, 235, 0.18)',
  danger: '0 8px 18px rgba(248, 113, 113, 0.24)',
};

export const transitions = {
  default: '0.2s ease',
};

export const spacing = (value: number) => `${value}px`;
